/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timecode_Shrink_StretchInputs */



/**
* | output |
* | --- |
* | "Timecode Shrink/Stretch" |
*
* @param {Timecode_Shrink_StretchInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timecode_shrink_stretch = /** @type {((inputs?: Timecode_Shrink_StretchInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timecode_Shrink_StretchInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Réduire/étirer le timecode")
	if (locale === "de") return /** @type {LocalizedString} */ ("Timecode-Verkleinerung/Verlängerung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Riduzione/allungamento del codice temporale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сжатие/растяжение таймкода")
	if (locale === "es") return /** @type {LocalizedString} */ ("Reducir/estirar el código de tiempo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("时间码收缩/拉伸")
	if (locale === "ja") return /** @type {LocalizedString} */ ("タイムコードの縮小/拡大")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टाइमकोड को छोटा/बड़ा करना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Encolhimento/Alongamento do código de tempo")
	return /** @type {LocalizedString} */ ("Timecode Shrink/Stretch")
});